var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__company" },
    [
      _c("h3", [_vm._v("Dane do faktury")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "company",
                name: "company.company",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_company_name"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: { id: "company", autocomplete: "organization" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "company", $$v)
                          },
                          expression: "data.company",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "vatid",
                name: "company.vatid",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_vatid"),
                labelWidth: 4,
                controlWidth: 3,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInputVatId", {
                        attrs: { id: "vatid" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.vatid,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "vatid", $$v)
                          },
                          expression: "data.vatid",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "street",
                name: "company.street",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_street"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: { id: "street" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.street,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "street", $$v)
                          },
                          expression: "data.street",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "streetNo",
                name: "company.streetNo",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_streetNo"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: { id: "streetNo" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.streetNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "streetNo", $$v)
                          },
                          expression: "data.streetNo",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "apartment",
                name: "address.apartment",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_apartment"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: { id: "apartment" },
                        on: {
                          input: function ($event) {
                            return _vm.$emit("input", _vm.data)
                          },
                        },
                        model: {
                          value: _vm.data.apartment,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "apartment", $$v)
                          },
                          expression: "data.apartment",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "zip",
                name: "company.zip",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_zip"),
                labelWidth: 4,
                controlWidth: 2,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInputZip", {
                        attrs: { id: "zip" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.zip,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "zip", $$v)
                          },
                          expression: "data.zip",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-9 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "city",
                name: "company.city",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_city"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: { id: "city" },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "city", $$v)
                          },
                          expression: "data.city",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("IcFormRowWrapper", {
        attrs: {
          id: "einvoice",
          name: "company.einvoice",
          labelWidth: 0,
          controlWidth: 12,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ validator }) {
              return [
                _c(
                  "IcCheckbox",
                  {
                    attrs: { id: "einvoice", val: 1 },
                    model: {
                      value: _vm.data.einvoice,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "einvoice", $$v)
                      },
                      expression: "data.einvoice",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("label_einvoice")))]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }